import { Button, Nav, NavLink } from 'reactstrap';
import { H5 } from '../../../../../AbstractElements';
import { businessNavData } from '../../../../../Data/Forms/FormLayout';
import { FaCircleCheck } from 'react-icons/fa6';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../ReduxToolkit/Store';

export default function BusinessNavComponent({ steps, activeCallBack }: any) {
    const formStatus = useSelector((state: RootState) => state.formStatus);
    const formData = useSelector((state: any) => state.formData);

    const calculateCompletionPercentage = (formData: any) => {
        if (Object.keys(formData).length === 0) {
            return 0;
        }

        const totalFields = Object.keys(formData).length;
        const filledFields = Object.values(formData).filter(value => value !== "" && value !== null && value !== "0").length;
        return Math.round((filledFields / totalFields) * 100);
    };

    const handleNavigation = (id: string, isNavigable: boolean) => {
        if (isNavigable) {
            activeCallBack(id);
        }
    };

    const isFirstTabSubmitted = formStatus["1"] === 1;

    return (
        <>
            <Nav className="horizontal-options" pills style={{ width: '100%' }}>
                {businessNavData.map((data : any) => {
                    const status = formStatus[data?.id?.toString()];
                    const isActive = steps === data.id;

                    const formId = data?.id?.toString();
                    const currentFormData = formData[formId];
                    const completionPercentage = calculateCompletionPercentage(currentFormData);

                    const isTabDisabled = data.id !== 1 && !isFirstTabSubmitted;
                    const isTabNavigable = (data.id === 1) || (isFirstTabSubmitted || status === 1);

                    return (
                        <NavLink
                            key={data.id}
                            className={isActive ? "active" : ''}
                            onClick={() => handleNavigation(data.id, isTabNavigable)}
                            style={{
                                backgroundColor: isActive ? 'blue' : (status === 1 ? '#C1E1C1' : 'transparent'),
                                borderRadius: '8px',
                                display: 'flex',
                                width: '100%',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                cursor: isTabNavigable ? 'pointer' : 'not-allowed',
                                opacity: isTabNavigable ? 1 : 0.5,
                            }}
                        >
                            <div className="horizontal-wizard">
                                <div className="stroke-icon-wizard">
                                    <span>{data.id}</span>
                                </div>
                                <div className="horizontal-wizard-content">
                                    <H5 className="f-w-600" style={{ color: isActive ? 'white' : 'black' }}>
                                        {data.title}
                                    </H5>
                                </div>
                            </div>

                            <div
                                style={{
                                    color: (status === 1) ? 'black' : (isActive ? 'white' : 'black'),
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                    marginLeft: 'auto',
                                    paddingRight: '10px',
                                }}
                            >
                                {`${completionPercentage}%`}
                            </div>

                            {status === 1 && (
                                <FaCircleCheck
                                    style={{ color: 'green', marginLeft: '10px', fontSize: '20px' }}
                                />
                            )}

                   
                        </NavLink>
                        
                    );
                })}
            </Nav>
        </>
    );
}
